import * as React from 'react';
type Props = {
  className?: string;
};
export function ThirtyOff({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-testid="illustrated-ThirtyOff"
      className={className}
    >
      <title>BuyMoreSaveMore_V3</title>
      <g
        id="BuyMoreSaveMore_V3"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Group-20"
          transform="translate(-2.500000, 0.000000)"
          stroke="currentColor"
          strokeWidth={1.30977}
        >
          <g
            id="Group-19"
            transform="translate(24.325897, 19.679509) rotate(-26.000000) translate(-24.325897, -19.679509) translate(2.825897, 8.679509)"
          >
            <polygon
              id="Stroke-1"
              points="33.5111158 10.2894125 31.639165 2.72008873 25.8914709 0.882356367 0.119941464 7.90519122 3.49549149 21.5543294 29.2670209 14.5314946"
            />
            <path
              d="M28.1544423,9.96401791 C27.2869038,10.1783865 26.4103074,9.64900683 26.1959389,8.78247476 C25.9815703,7.91493626 26.51095,7.03833993 27.377482,6.82397137 C28.2450205,6.60960281 29.1216169,7.13797603 29.3359854,8.00551452 C29.550354,8.87305302 29.0219808,9.74964935 28.1544423,9.96401791 Z"
              id="Stroke-3"
            />
            <path
              d="M28.993197,8.09136259 C31.9581256,8.15879308 33.7767359,7.15236791 34.5224969,6.59178909 C43.0177318,0.207027792 45.88705,10.7050488 37.1623501,9.66943726 C36.8171463,9.62918026 34.1289847,9.09174921 33.7928387,9.16018613"
              id="Stroke-17"
            />
          </g>
        </g>
        <path
          d="M12.6195498,25 C12.842565,23.529561 14.1732353,22.4667534 15.6382616,22.5329174 C17.0052549,22.5948987 18.1746201,23.625765 18.3816219,24.9935357 L21,24.9935357 C20.9722696,24.7741296 20.5332694,21.7252597 17.7856128,20.4814516 C16.1253018,19.7296911 14.5751314,20.0563286 14.1529257,20.1605179 C12.2551484,20.6297503 10.8787814,22.0446724 10.3116745,23.5455316 C10.095299,24.1166719 10.0238247,24.6288729 10,24.9942962 C10.8733134,24.9961975 11.7462363,24.9980987 12.6195498,25 Z"
          id="Stroke-4"
          stroke="currentColor"
          strokeWidth={1.35}
          transform="translate(15.500000, 22.500000) rotate(-41.000000) translate(-15.500000, -22.500000) "
        />
      </g>
    </svg>
  );
}
